import client from "./client";
import type { Survey, PresignResponse, SurveysListResponse } from "@/types";

export async function getPresignedUrl(
  filename: string,
  contentType: string,
): Promise<PresignResponse> {
  const { data } = await client.post<PresignResponse>("/v1/surveys/presign", {
    filename,
    content_type: contentType,
  });
  return data;
}

export async function uploadFileToS3(url: string, file: File): Promise<void> {
  const response = await fetch(url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!response.ok) {
    throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`);
  }
}

export async function createSurvey(params: {
  customer_name: string;
  customer_phone: string;
  pdf_s3_key: string;
  configuration: Record<string, unknown>;
}): Promise<Survey> {
  const { data } = await client.post<Survey>("/v1/surveys", params);
  return data;
}

export async function listSurveys(): Promise<SurveysListResponse> {
  const { data } = await client.get<SurveysListResponse>("/v1/surveys");
  return data;
}

export async function getSurvey(id: string): Promise<Survey> {
  const { data } = await client.get<Survey>(`/v1/surveys/${id}`);
  return data;
}
